import React from 'react';
import { Table } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import bt from '../../../components/commonStyle.css';

import cx from 'classnames';
import s from './PaymentGatewayList.css';
import withStyles from 'isomorphic-style-loader/withStyles';
import messages from '../../../locale/messages';
import { updatePaymentMethod } from "../../../actions/siteadmin/Payout/updatePayout";

class PaymentGatewayList extends React.Component {

    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this);
    }

    label(value, locale) {
        if (locale !== 'ar') return value;
        return {
            Cash: 'نقداً', 'Credit/Debit': 'بطاقة ائتمان/خصم', Wallet: 'المحفظة', GooglePay: 'Google Pay'
        }[value] || value;
    }

    async handleChange(e, id) {
        const { updatePaymentMethod } = this.props;
        let status = e.target.value == 'true' ? true : false;
        await updatePaymentMethod(id, status);
    }

    render() {
        const { getPaymentMethods } = this.props;
        const { formatMessage, locale } = this.props.intl;
        const ar = locale === 'ar';
        return (
            <div className={cx(s.widthInner, 'whiteDropdown', 'bgBlackTwo', s.paymentInner)}>
                <div class="clearfix"></div>
                <div className={cx(s.tableCss, 'tableCss', 'tableSticky', 'NewResponsiveTable', 'topScrollbarTable', 'paymentTable')}>
                    <Table className={cx("table", 'topScrollbarTableContent')}>
                        <thead>
                            <tr>
                                <th scope="col">{ar ? 'المعرّف' : <FormattedMessage {...messages.id} />}</th>
                                <th scope="col">{ar ? 'بوابة الدفع' : <FormattedMessage {...messages.paymentGateWay} />}</th>
                                <th scope="col">{ar ? 'الحالة' : <FormattedMessage {...messages.status} />}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                getPaymentMethods && getPaymentMethods.results && getPaymentMethods.results.length > 0 && getPaymentMethods.results.map((item, index) => {
                                    let status = item.isEnable ? 'true' : 'false';
                                    return (
                                        <tr key={index}>
                                            <td data-label={formatMessage(messages.id)}>{item && item.id}</td>
                                            <td data-label={ar ? 'بوابة الدفع' : formatMessage(messages.paymentGateWay)}>{item && this.label(item.paymentName, locale)}</td>
                                            <td data-label={ar ? 'الحالة' : formatMessage(messages.status)}>
                                                <select name="isEnable" onChange={(e) => this.handleChange(e, item.id)} className={bt.selectInput} value={status}>
                                                    <option value="true">{ar ? 'نشطة' : formatMessage(messages.active)}</option>
                                                    <option value="false">{ar ? 'غير نشطة' : formatMessage(messages.inactive)}</option>
                                                </select>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    }
}
const mapState = (state) => ({
});

const mapDispatch = {
    updatePaymentMethod
};
export default compose(injectIntl,
    withStyles(s, bt),
    connect(mapState, mapDispatch)
)(PaymentGatewayList);
